<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit"
      :total="total" :showIndex="true" :btns="btns" :showTotal="true" :getTotal="getTotal"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../../hireTable";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'contract',
      getListUrl: 'orderec',
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            // console.log(id)
            this.$router.push(
              `/order/contractdetail?id=${id}&mode=view`
            );
          },
        },
      ],
    };
  },
  methods: {},
  created() {
    const { user_group_id } = this.user
    if ([1, 2, 3, 4, 5].includes(user_group_id)) {
      this.btns[0] = {
        ...this.editBtn,
        cb: ({ id }) => {
          // console.log(id)
          this.$router.push(
            `/order/contractdetail?id=${id}&mode=edit`
          );
        },
      }
    }
  },
  mounted() { },
};
</script>
